module.exports = __webpack_public_path__ + "img/SkyserviceLogo2022.90cb5ad0.svg";